import { serviceRoles } from "config/access";
import { TEMPLATE } from "constants/routes";
import { checkAccess } from "helpers/auth";
import ProjectPage from "./container/TemplatePage";

export default function getSettingsRoute(userAuth) {
  const { account, rhapsody } = serviceRoles;
  const requireAuth = {
    [rhapsody.name]: [account.roles.user],
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: TEMPLATE,
    withSidebar: true,
    withAppBar: true,
    component: ProjectPage,
  };
}
